<template>
    <div class="media-container" :class="{ 'video-upload' : registeredVideoUrl || showPlayButton}">
        <button v-if="!isVideoUploader && showEditButtons" class="label-button" @click="editGridSection"> {{ kStrings.kGLOB_EDIT }} </button>
        <div v-show="showEditButtons" class="area-close" @click.prevent="clearGridSection">
            <i class="label-close ecom-close"/>
        </div>
        <div class="media-upload-layer" :class="{'no-controls' : disabeLayerEvents}">
            <input v-if="uploadMode && (!previewImage && !previewVideo)" :key="'file-' + position" type="file" class="custom-file-input" :id="'file-' + position"
                   :accept="inputFileAccept"
                   @change.self.prevent="fileClick"
                   @drop.self.prevent="dragAndDrop"
                   @dragenter.self.prevent="dragAndDrop"
                   @dragleave.self.prevent="dragAndDrop"
                   @dragover.self.prevent="dragAndDrop"
            />
            <div v-if="uploadMode && (!previewImage && !previewVideo)" class="info-wrapper">
                <i class="ecom-plus"/>
                <p class="description">
                    {{ uploadDescription }}
                </p>
                <p class="description small">
                    {{ kStrings.kOR_DRAG_AND_DROP }}
                </p>
                <p v-if="mainMedia" class="description small">
                    {{ kStrings.kMAIN_PHOTO }}
                </p>
            </div>
            <img v-if="uploadMode && previewImage" :src="previewImage.src" class='media-image' :alt="previewImage.alt">
            <img v-if="registeredImageUrl" :src="registeredImageUrl" class='media-image' :alt="mediaId">
            <video v-if="uploadMode && previewVideo" class="video-media"
                   @loadedmetadata="videoSetup"
                   :id="videoPlayerId" 
                   :ref="videoPlayerId"
                   preload="metadata"
            >
                  <source :id="mediaId" :src="previewVideo.src">
            </video>
            <StreamPlayer v-if="registeredVideoUrl" :video="videoPlayerObject" :force-native="true" class="video-media plugin-player" />
            <div v-if="placeHolderMode" class="info-wrapper">
                <i class="ecom-logo-mini"/>
            </div>
            <div v-if="showPlayButton" class="info-wrapper play-action" @click="playVideo">
                <i class="ecom-play"/>
            </div>
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import browser from "@/Utilities/browser";
import {isEmpty} from 'lodash-es';


import StreamPlayer from '@/components/Muffin/Video/Component';

export default {
    store,
    name: 'MediaUploader',
    components: {
        StreamPlayer
    },
    props: {
        position: {type: Number, default: 0},
        singleMedia: {type: Boolean, default: false},
        mainMedia: {type: Boolean, default: false}, // this will be the block/presentation photo/video
        isVideoUploader: {type: Boolean, default: false}
    },
    data() {
        return {
            videoElm: null,
            isPlaying: false
        }
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        customerInfo() {
            return this.$store.getters['registrationPage/customerInfo'];
        },
        contestId() {
            return this.$store.getters.contestId;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        mediaType() {
            if(!this.isVideoUploader) {
                return 'image';
            }
            return 'video';
        },
        videoSettings() {
            return this.$store.getters.pastimeInfo.detailedInfo.videoSettings;
        },
        submissionInfo() {
            return this.$store.getters['contestantPage/registrationInfo'];
        },
        photoUploadUploadDescription() {
            return this.singleMedia ? this.kStrings.kADD_PHOTO : this.kStrings.kUPLOAD_PHOTOS;  
        },
        videoUploadDescription() {
            return this.singleMedia ? this.kStrings.kUPLOAD_VIDEO_HERE : this.kStrings.kUPLOAD_VIDEOS_HERE;
        },
        uploadDescription() {
            return !this.isVideoUploader ? this.photoUploadUploadDescription : this.videoUploadDescription;
        },
        registeredImageUrl() {
            if(isEmpty(this.submissionInfo)) {
                return null;
            }
            
            if(!isEmpty(this.submissionInfo.imageList) && this.submissionInfo.imageList[this.position]) {
                return this.submissionInfo.imageList[this.position];
            }
            
            return this.submissionInfo.imageUrl ? this.submissionInfo.imageUrl: null;
        },
        registeredVideoUrl() {
            if(isEmpty(this.submissionInfo)) {
                return null;
            }

            if(!isEmpty(this.submissionInfo.videoList) && this.submissionInfo.videoList[this.position]) {
                return this.submissionInfo.videoList[this.position];
            }

            return this.submissionInfo.videoUrl ? this.submissionInfo.videoUrl: null;
        },
        activePage() {
            return this.$store.getters.activePage;
        },
        uploadMode() {
            if(!this.isVideoUploader) {
                return this.activePage == 'registration' && !this.registeredImageUrl;
            }
            
            return this.activePage == 'registration' && !this.registeredVideoUrl;
        },
        modalStatus() {
            return this.$store.getters.modalStatus;
        },
        mediaGridUpload() {
            return this.$store.getters['registrationPage/mediaGridUpload'];
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        typeImageEdit() {
            return !isEmpty(this.modalData) && this.modalData.contentType == 'imageEdit';
        },
        previewImage() {
            if(this.isVideoUploader) {
                return null;
            }
            let foundGridPreview = !isEmpty(this.mediaGridUpload) ? this.mediaGridUpload.find(elm => elm.position == this.position) : null;
            return !isEmpty(foundGridPreview) && !isEmpty(foundGridPreview.mediaData.src) && foundGridPreview.mediaData
                ? foundGridPreview.mediaData
                : null;
        },
        previewVideo() {
            if(!this.isVideoUploader) {
                return null;
            }
            
            let foundGridPreview = !isEmpty(this.mediaGridUpload) ? this.mediaGridUpload.find(elm => elm.position == this.position) : null;
            return !isEmpty(foundGridPreview) && !isEmpty(foundGridPreview.mediaData.src)
                ? foundGridPreview.mediaData
                : null;
        },
        placeHolderMode() {
            if(!this.isVideoUploader) {
                return this.activePage == 'voting' && !this.registeredImageUrl;
            }
            
            return this.activePage == 'voting' && !this.registeredVideoUrl;
        },
        forceHideEditButtons() {
            return this.$store.getters['registrationPage/forceHideEditButtons'];
        },
        showEditButtons() {
            return !this.forceHideEditButtons && (this.uploadMode && (this.previewImage || this.previewVideo));  
        },
        inputFileAccept() {
           return !this.isVideoUploader ? 'image/jpg, image/jpeg, image/png': 'video/*';  
        },
        mediaId() {
            let pastimeId = this.contestId;
            //let customerId = this.customerInfo.info.customer_id;
            return pastimeId + '-media-pos-' + this.position;
        },
        videoPlayerId() {
            return 'videoApp-' + this.position;  
        },
        maxFileSizeBytes(){
            let maxFileSize = this.videoSettings.maxFileSizeMB ? this.videoSettings.maxFileSizeMB : 200;
            return maxFileSize * 1000 * 1000;
        },
        isSafari() {
            return browser.isSafari();
        },
        videoPlayerObject() { // for PARTICPANT PAGE ONLY -> PDP COMPONENT
            return {
                source: this.registeredVideoUrl,
                sourceFull: this.registeredVideoUrl,
                options: {
                    poster: this.submissionInfo.blockThumbnail,
                    autoPlay: false,
                    width: '100%',
                    height: '100%',
                    loop: false,
                    muted: true,
                    events: {
                        onPlay: () => {},
                        onEnded: () => {},
                    }
                }
            }

        },
        showPlayButton() {
            if(this.isPlaying) {
                return false;
            }
            return this.isVideoUploader && (this.uploadMode && (this.previewVideo || this.registeredVideoUrl))
        },
        disabeLayerEvents() { // for now, only cursor
            return this.registeredImageUrl || this.registeredVideoUrl ||  (this.uploadMode && (this.previewVideo || this.previewImage));
        },
    },
    watch: {},
    created() {
    },
    mounted() {},
    methods: {
        clearGridSection() {
            if(this.showEditButtons) {
                let pastimeId = this.contestId;
                let customerId = this.customerInfo.info.customer_id;
                let imageId = pastimeId + '-' + customerId + '-pos-' + this.position;
                let defaultGrid = {
                    position: this.position,
                    type: 'image',
                    mediaData: {
                        src: '',
                        alt: imageId,
                        file: null
                    }
                };
                    
                if(this.isVideoUploader) {
                    defaultGrid = {
                        position: this.position,
                        type: 'video',
                        mediaData: {
                            src: '',
                            thumbnail: '',
                            file: null
                        }
                    };
                }
                
                this.$store.dispatch('registrationPage/setMediaGridUpload', defaultGrid);
            }
        },
        editGridSection() { // for now, img only
            if(this.showEditButtons) {
                let editGrid = {
                    position: this.position,
                    src: this.previewImage?.original ?? this.previewImage.src,
                    alt: this.previewImage.alt,
                    box: this.previewImage?.box ?? null,
                }
                
                this.modalControl(true, 'imageEdit', editGrid);
            }
        },
        fileClick(e) {
            this.handleFiles(e.target.files);
            e.target.value = "";
        },
        dragAndDrop(e) {
            let dt = e.dataTransfer;
            let files = dt.files;

            if (files.length < 1) {
                return;
            }

            this.handleFiles(files);
        },
        handleFiles(files) {
            let _files = [...files];
            this.$store.dispatch('setLoading',true);
            setTimeout(()=>{
                if(!this.isVideoUploader){
                    _files.forEach(this.previewImageFile);
                } else {
                    _files.forEach(this.previewVideoFile);
                }
            },0);
        },
        previewImageFile(file) { // image
            let URL = window.URL || window.webkitURL;
            let pastimeId = this.contestId;
            let customerId = this.customerInfo.info.customer_id;
            let imageId = pastimeId + '-' + customerId + '-pos-' + this.position;
            let fileData = {
                position: this.position,
                src: URL.createObjectURL(file),
                alt: imageId
            };
            this.modalControl(true, 'imageEdit', fileData);
        },
        previewVideoFile(file) {
            this.$store.dispatch('setLoading',true);
            if(this.maxFileSizeBytes && this.maxFileSizeBytes < file.size){
                // file is bigger than allowed
                this.$store.dispatch(this.notificationDispatch, {
                    type: 'error',
                    text: this.kStrings.kVIDEO_SEND_FILE.replace("{{pp_number}}", this.videoSettings.maxFileSizeMB),
                    duration: 10000
                });
                
                this.$store.dispatch('setLoading',false);
                return;
            }
            //let URL = window.URL || window.webkitURL;
            let reader = new FileReader();
            reader.onload = (e) => {
                let parsedGrid = {
                    position: this.position,
                    type: 'video',
                    mediaData: {
                        src: e.target.result,
                        thumbnail: '',
                        file: file
                    },
                };
                this.$store.dispatch('registrationPage/setMediaGridUpload', parsedGrid);
            };
            reader.readAsDataURL(file);
        },
        // goes to parent instead?
        modalControl(status = false, context = '', file = null) {
            this.$store.dispatch('setLoading',false);
            this.$store.dispatch('setModalStatus', {status: status, context: context, file: file});
        },
        videoSetup() {
            this.videoElm = document.getElementById(this.videoPlayerId);
            let videoDuration = Math.floor(this.videoElm.duration / 60);
            // default setting: < 30 minutes
            if(videoDuration > this.videoSettings.maxDurationMinutes) {
                this.$store.dispatch(this.notificationDispatch, {
                    type: 'error',
                    text: this.kStrings.kVIDEO_TOO_LONG,
                    duration: 10000
                });
                this.clearGridSection();
            } else {
                this.videoElm.onplay = (event) => {
                    this.isPlaying = true;
                    this.videoElm.controls = true;
                };

                this.videoElm.onpause = (event) => {
                    this.isPlaying = false;
                    this.videoElm.controls = false
                };
                // add on error
            }
            this.$store.dispatch('setLoading',false);
        },
        playVideo() {
            if(this.videoElm) {
                this.videoElm.play();
            } else {
                this.videoElm = document.getElementById(this.videoPlayerId);
                this.videoElm.play();
            }
        }
    }
};
</script>

<style scoped>

</style>